import useRegisterDiagnosticChecklist from "routes/home/my-courses/common/diagnostics/useRegisterDiagnosticChecklist.ts";
import { DiagnosticChecklist } from "routes/home/my-courses/common/diagnostics/diagnosticChecklistTypes.ts";
import { ProgramScope } from "routes/home/common/courses/buildProgramDetails.ts";

interface ProgramBannerDiagnostics {
  programAllowsBanner: boolean;
  scope: ProgramScope;
  allowsOptOut: boolean;
  showStudentChoiceCountdownBanner: boolean;
  optWindowOpen: boolean;
  termActive: boolean | undefined;
  optDeadline: string | undefined;
  isDefinitelyALearner: boolean;
  isInstructor: boolean | null;
  hideForStore: boolean;
  isVirtualStore: boolean;
  requiredToPurchaseBaseCount: number;
  showBanner: boolean;
}

function buildChecklist({
  programAllowsBanner,
  scope,
  allowsOptOut,
  showStudentChoiceCountdownBanner,
  optWindowOpen,
  termActive,
  optDeadline,
  isDefinitelyALearner,
  isInstructor,
  hideForStore,
  isVirtualStore,
  requiredToPurchaseBaseCount,
  showBanner,
}: ProgramBannerDiagnostics): DiagnosticChecklist {
  return {
    id: "program-banner",
    title: "Program Banner",
    items: [
      {
        label: "Program scope allows the banner",
        status: programAllowsBanner ? "pass" : "fail",
        detail: [
          `scope: ${scope ?? "null"}`,
          `allowsOptOut: ${allowsOptOut}`,
          `showStudentChoiceCountdownBanner: ${showStudentChoiceCountdownBanner}`,
        ],
      },
      {
        label: "Opt-out window is open",
        status: optWindowOpen ? "pass" : "fail",
        detail: [
          `active: ${termActive}`,
          `optDeadline: ${optDeadline ?? "null"}`,
        ],
      },
      {
        label: "User is a learner (not instructor-only)",
        status: isDefinitelyALearner ? "pass" : "fail",
        detail: [`isInstructor: ${isInstructor}`],
      },
      {
        label: "Not hidden for a virtual store with nothing to purchase",
        status: !hideForStore ? "pass" : "fail",
        detail: [
          `isVirtualStore: ${isVirtualStore}`,
          `requiredToPurchaseBaseCount: ${requiredToPurchaseBaseCount}`,
        ],
      },
      {
        label: "Banner will actually display",
        status: showBanner ? "pass" : "fail",
      },
    ],
  };
}

// Receives already-computed values instead of deriving them here. showBanner,
// programAllowsBanner, isDefinitelyALearner, and hideForStore are the exact
// values that gate the real banner, so a diagnostic here cannot disagree with
// what the banner does.
export default function useProgramBannerDiagnostics(
  diagnostics: ProgramBannerDiagnostics
) {
  useRegisterDiagnosticChecklist(buildChecklist(diagnostics));
}
